import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>Portfolio</Typography>
          <Typography className={classes.description} >Welcome to my online portfolio. Below you can see some of the works developed by me. If you want to know more information about me, check my curriculum by clicking on 'View Resume'.</Typography>
          <div style={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              href="/resume"
              style={{ marginTop: '4vh', color: "#FCFCFC", background: "#84a086" }}
              startIcon={<DescriptionIcon />}
            >
              View Resume
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};


export default Header;